import * as tslib_1 from "tslib";
import { Record } from '@swim/recon';
import { SvgView, } from '@swim/ui';
import { FlowView } from './flow-view';
var FlowController = (function (_super) {
    tslib_1.__extends(FlowController, _super);
    function FlowController(view) {
        var _this = _super.call(this, view.parentView.node) || this;
        _this.view = view;
        return _this;
    }
    FlowController.prototype.didReview = function (viewable) {
        _super.prototype.didReview.call(this, viewable);
    };
    FlowController.prototype.didResize = function () {
        _super.prototype.didResize.call(this);
        this.view.resize();
        this.view.render();
    };
    FlowController.prototype.didSetState = function (newState, oldState) {
        _super.prototype.didSetState.call(this, newState, oldState);
        var meter = newState.get('meter').numberValue();
        if (meter !== undefined) {
        }
    };
    FlowController.create = function () {
        var view = FlowView.create();
        return new FlowController(view);
    };
    FlowController.applyTheme = function (theme) {
        var properties = Record.empty()
            .slot('meter', '0');
        theme.set('flow', properties);
    };
    return FlowController;
}(SvgView));
export { FlowController };
FlowController.applyTheme(FlowController.Theme);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxvdy1jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmxvdy1jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQVMsTUFBTSxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBQzVDLE9BQU8sRUFFTCxPQUFPLEdBQ1IsTUFBTSxVQUFVLENBQUM7QUFDbEIsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUV2QztJQUFvQywwQ0FBTztJQUd6Qyx3QkFBWSxJQUFjO1FBQTFCLFlBQ0Usa0JBQU0sSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsU0FFNUI7UUFEQyxLQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQzs7SUFDbkIsQ0FBQztJQUVELGtDQUFTLEdBQVQsVUFBVSxRQUFpQjtRQUN6QixpQkFBTSxTQUFTLFlBQUMsUUFBUSxDQUFDLENBQUM7SUFFNUIsQ0FBQztJQUVELGtDQUFTLEdBQVQ7UUFDRSxpQkFBTSxTQUFTLFdBQUUsQ0FBQztRQUNsQixJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQ25CLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7SUFDckIsQ0FBQztJQUVELG9DQUFXLEdBQVgsVUFBWSxRQUFlLEVBQUUsUUFBZTtRQUMxQyxpQkFBTSxXQUFXLFlBQUMsUUFBUSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBSXRDLElBQU0sS0FBSyxHQUFHLFFBQVEsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUM7UUFDbEQsRUFBRSxDQUFDLENBQUMsS0FBSyxLQUFLLFNBQVMsQ0FBQyxDQUFDLENBQUM7UUFFMUIsQ0FBQztJQUNILENBQUM7SUFFTSxxQkFBTSxHQUFiO1FBQ0UsSUFBTSxJQUFJLEdBQUcsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQy9CLE1BQU0sQ0FBQyxJQUFJLGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBR00seUJBQVUsR0FBakIsVUFBa0IsS0FBYTtRQUM3QixJQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsS0FBSyxFQUFFO2FBQzlCLElBQUksQ0FBQyxPQUFPLEVBQUUsR0FBRyxDQUFDLENBQUM7UUFDdEIsS0FBSyxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUUsVUFBVSxDQUFDLENBQUM7SUFDaEMsQ0FBQztJQUNILHFCQUFDO0FBQUQsQ0FBQyxBQXpDRCxDQUFvQyxPQUFPLEdBeUMxQzs7QUFDRCxjQUFjLENBQUMsVUFBVSxDQUFDLGNBQWMsQ0FBQyxLQUFLLENBQUMsQ0FBQyJ9